<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="68">
    <div class="content-top">
      <div class="content-title">权限组设置</div>
      <FormItem label="权限组" prop="name" :error="nameError">
        <Input v-model="formValidate.name" placeholder="请输入权限组名称"></Input>
      </FormItem>
      <p class="content-hint" style="margin-bottom: 4px">为权限组设置特定名称，便于添加管理员时选择使用</p>
      <FormItem label="账号权限">
        <Checkbox :value="totalSel" @click.prevent.native="CheckAll()">全部操作</Checkbox>
      </FormItem>
      <p class="content-hint">勾选后选中全部操作功能，可根据需要从设置详情中进行分组设置</p>
    </div>
    <div class="content-bottom" v-loading="loading">
      <p class="content-title">权限详情</p>
      <ul>
        <checkboxLine
          v-for="(item,index) in limitData"
          :line="item"
          :key="item.id"
          :index="index"
          @change="change"
        ></checkboxLine>
      </ul>
    </div>
    <div class="content-footer">
      <FormItem>
        <Button type="primary" @click="handleSubmit">提交保存</Button>
      </FormItem>
    </div>
  </Form>
</template>
<script>
import { getJurisdictionDetails, getJurisdictionCheck } from '@/api/app'
import checkboxLine from './components/checkboxLine'
import axios from 'axios'
export default {
  components: { checkboxLine },
  props: ['nameError'],
  data() {
    return {
      formValidate: {
        name: '',
        gid: ''
      },
      loading: false, // loading
      ruleValidate: {
        name: [
          { required: true, message: '权限组不能为空', trigger: 'blur' }
        ]
      },
      totalSel: false, // 账号权限总的数据 从这一下----封
      limitData: '' // 权限列表的总数据
    }
  },
  mounted() {
    if (this.$route.query.id !== undefined) {
      this.formValidate.name = this.$route.query.name
      this.formValidate.gid = this.$route.query.id
      axios.all([
        getJurisdictionDetails(),
        getJurisdictionCheck({ gid: this.$route.query.id })
      ]).then(axios.spread((res1, res2) => {
        this.resetDetail(res1)
        this.resetCheck(res2)
      }))
    } else {
      getJurisdictionDetails().then(res => {
        this.resetDetail(res)
      })
    }
  },
  methods: {
    // 提交
    handleSubmit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          const obj = {}
          this.limitData.forEach(item => {
            obj[item.id] = item.allSel
          })
          this.$emit('jurisdictionWay', {
            name: this.formValidate.name,
            gid: this.formValidate.gid,
            limits: obj
          })
        } else {
          return false
        }
      })
    },
    // 全部操作
    CheckAll() {
      this.totalSel = !this.totalSel
      this.limitData.forEach(item => {
        item.isSel = this.totalSel
        if (this.totalSel) {
          item.allSel = item.children.map(subItem => {
            return subItem.id + ''
          })
        } else {
          item.allSel = []
        }
      })
    },
    resetDetail(res) { // 处理权限列表数据
      if (res.code === 0) {
        if (res.result && res.result.length) {
          this.limitData = res.result.map(item => {
            item.isSel = false
            item.allSel = []
            return item
          })
        }
      } else if (res.code !== 10008) {
        this.$Message.info(res.msg)
      }
    },
    resetCheck(res) {
      if (res.code === 0) {
        const limits = JSON.parse(res.result.data[0].limits)
        let Flag = true
        this.limitData.forEach(item => {
          item.allSel = limits[item.id]
          item.isSel = item.children.length === (limits[item.id] && limits[item.id].length)
          if (!item.isSel) {
            Flag = false
          }
        })
        this.totalSel = Flag // 全局选定的样式
      } else if (res.code !== 10008) {
        this.$Message.info(res.msg)
      }
    },
    change(index, allSel, isSel) {
      this.limitData[index].allSel = allSel
      this.limitData[index].isSel = isSel
      let Flag = true
      this.limitData.forEach(item => {
        if (item.isSel === false) {
          Flag = false
        }
      })
      this.totalSel = Flag
    }
  }
}
</script>
<style lang="scss">
  .content-title{
    font-size:14px;
    font-weight:600;
    color:rgba(93,111,128,1);
    line-height:14px;
  }
  .content-hint{
    padding-left: 68px;
    font-size:12px;
    font-weight:400;
    color:rgba(181,194,208,1);
    line-height:12px;
  }
  .content-top,.content-bottom {
    padding: 30px 20px;
    background: rgba(255,255,255,1);
    box-shadow: 0 4px 8px 1px rgba(135,150,176,0.09);
  }
  .content-top {
    padding-left: 30px;
    margin-bottom: 10px;
    .content-title {
      margin-left: -10px;
      margin-bottom: 24px;
    }
    .ivu-form-item {
      margin-bottom: 10px;
    }
    .ivu-form-item-content {
      height: 32px;
      line-height: 32px;
    }
    .ivu-input-wrapper {
      width: 210px;
      .ivu-input {
        width:210px;
        height:32px;
        line-height: 32px;
        border-radius:4px;
      }
    }
    .ivu-form-item-error-tip {
      top: 0;
      left: 0;
    }
    .ivu-form-item .ivu-form-item-label {
      padding-left: 0;
    }
  }
  .content-bottom {
    .ivu-checkbox-group {
      display: inline-block;
    }
    .content-title {
      margin-bottom: 19px;
    }
    li {
      line-height: 40px;
      box-sizing: content-box;
      white-space: nowrap;
      overflow: hidden;
      height: 40px;
      border-bottom: 1px solid #D9E2EF;
      .ivu-checkbox-group .checkbox-val{
        display: inline-block;
        width: 194px;
        margin-right: 0;
      }
      .ivu-checkbox-wrapper {
        margin-right: 0;
      }
      .checkbox-all {
        .ivu-checkbox-wrapper span:last-child{
          display: inline-block;
          width: auto;
          margin: 0 60px;
          color: #D9E2EF;
        }
      }
    }
  }
  .content-footer {
    text-align: right;
    margin-top: 30px;
    padding-right: 20px;
    .ivu-form-item-content {
      height: 28px;
      line-height: 28px;
      .ivu-btn>span{
        vertical-align: bottom;
      }
    }
  }
</style>

